import { useState, useCallback } from 'react';
// https://stackoverflow.com/questions/56995736/react-error-boundaries-not-working-properly-with-async-function
/** A workaround for error boundary async limitations. */
export const useAsyncThrow = () => {
  const [_, setErr] = useState();
  return useCallback(
    (e) =>
      setErr(() => {
        throw e;
      }),
    [setErr]
  );
};
